namespace GeniuzPOS.AdvPromo {
    export namespace PsPromoAvShopService {
        export const baseUrl = 'AdvPromo/PsPromoAvShop';

        export declare function Create(request: Serenity.SaveRequest<PsPromoAvShopRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoAvShopRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoAvShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoAvShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsPromoAvShop/Create",
            Update = "AdvPromo/PsPromoAvShop/Update",
            Delete = "AdvPromo/PsPromoAvShop/Delete",
            Retrieve = "AdvPromo/PsPromoAvShop/Retrieve",
            List = "AdvPromo/PsPromoAvShop/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoAvShopService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
